import React from 'react'
import styled from 'styled-components'
import { Flex } from 'styling/GlobalStyles'
import { MediumText } from 'styling/TypographyV2'

export const DotText = ({
  hexColor,
  children,
}: {
  hexColor: string
  children: React.ReactNode
}) => {
  return (
    <Flex center gap='8px'>
      <Dot hexColor={hexColor} />
      <MediumText hexColor={hexColor} uppercase>
        {children}
      </MediumText>
    </Flex>
  )
}

const Dot = styled.div<{ hexColor: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ hexColor }) => hexColor};
`
